export enum Breakpoints {
    xxsMax = 320,
    xsMin = 321,
    xsMax = 375,
    smMin = 376,
    smMax = 464,
    mdMin = 465,
    mdMax = 744,
    lgMin = 745,
    lgMax = 984,
    xlMin = 985,
    xlMax = 1439,
    xxlMin = 1440,
}
